import { apiForPrivate } from '.';
import { TRANSMISSION_LOGS_ENDPOINT } from '../../config/ap';

const apiLogs = apiForPrivate.injectEndpoints({
  overrideExisting: true,
  endpoints: build => ({
    getTransmissionLog: build.query({
      query: id => `${TRANSMISSION_LOGS_ENDPOINT.LOGS}/${id}`,
    }),
    getTransmissionLogs: build.query({
      query: page => ({
        url: `${TRANSMISSION_LOGS_ENDPOINT.LOGS}`,
        params: page
      })
    }),
    resendTransmissionLog: build.mutation({
      query: id => ({
        url: `${TRANSMISSION_LOGS_ENDPOINT.LOGS}/${id}`,
        method: 'POST',
      }),
    }),
    resendAllTransmissionLog: build.mutation({
      query: () => ({
        url: `${TRANSMISSION_LOGS_ENDPOINT.LOGS}`,
        method: 'POST',
      }),
    }),
    deleteTransmissionLog: build.mutation({
      query: id => ({
        url: `${TRANSMISSION_LOGS_ENDPOINT.LOGS}/${id}`,
        method: 'DELETE',
      }),
    }),
    exportTransmissionLogs: build.query({
      query: page => ({
        url: `${TRANSMISSION_LOGS_ENDPOINT.LOGS}/export`,
        params: page,
        responseHandler: (response: any) => response.text(),
      })
    }),
  })
});

export const {
  useLazyGetTransmissionLogQuery,
  useLazyGetTransmissionLogsQuery,
  useResendTransmissionLogMutation,
  useResendAllTransmissionLogMutation,
  useDeleteTransmissionLogMutation,
  useLazyExportTransmissionLogsQuery,
} = apiLogs;